<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import {Russian} from 'flatpickr/dist/l10n/ru.js'
import moment from 'moment'
import StatisticChart from "@views/pages/calls/statistic-chart";

export default {
	page: {
		title: 'Статистика звонков',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: {StatisticChart, Layout, PageHeader },

	data() {
		return {
			title: 'Статистика звонков',
            items: [],
            tableData: [],
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: null,
            sortBy: 'created_at',
            sortDesc: true,
            showModal: false,
            modal_variables: [],
            record: null,

            fields: [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'created_at', label: 'Дата', sortable: true },
                { key: 'contact_fullname', label: 'Контакт', sortable: true },
                { key: 'contact_phone', label: 'Контактный номер', sortable: true },
                { key: 'call_type', label: 'Тип звонка', sortable: true },
                { key: 'bot_name', label: 'Сценарий', sortable: true },
                { key: 'account_number', label: 'Аккаунт', sortable: true },
                { key: 'bill_sec', label: 'Длительность', sortable: true },
                { key: 'tariff_name', label: 'Тариф', sortable: true },
                { key: 'cost', label: 'Стоимость', sortable: true },
                { key: 'retries', label: 'Попытки', sortable: true },
                { key: 'status', label: 'Статус', sortable: true },
                { key: 'caller_number', label: 'Вызывающий номер', sortable: true },
                { key: 'trunk_name', label: 'Транк', sortable: true },
                { key: 'updated_at', label: 'Обновлено', sortable: true },
                { key: 'delayed_at', label: 'Отложен', sortable: true },                
                { key: 'action',label: ''}
            ],
            dateConfig: {
                mode: 'range',
                locale: Russian,
                dateFormat: 'd.m.Y',
            },

            tableLoading: true,
            watch: false,

            date_start: moment().subtract('days', 1).format('DD.MM.YYYY'),
            date_end: moment().format('DD.MM.YYYY'),
            selectedDate: [moment().subtract('days', 1).format('DD.MM.YYYY'), moment().format('DD.MM.YYYY')],

		}
	},

    watch: {
        sortBy: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        sortDesc: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onSorted();
                }
            }
        },
        perPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangePerPage();
                }
            }
        },
        currentPage: {
            immediate: true,
            async handler(values) {
                if(this.watch === true) {
                    await this.onChangeCurrentPage();
                }
            }
        },
    },
    computed: {
        total_rows() {
            return this.$store.getters['calls/GET_CALLS_TOTAL_ROWS'];
        },
        table_data() {
            this.tableLoading = false;
            return this.$store.getters['calls/GET_CALLS_TABLE_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
        session_item(){
            return this.$store.getters['sessions/GET_SESSIONS_ITEM'];
        }
    },

    async mounted() {

        if(this.session_user_item && this.session_user_item.role === 'administrator'){
            this.fields = [
                { key: 'select',   label: '', row:{'rowSelected':false}},
                { key: 'created_at', label: 'Дата', sortable: true },
                { key: 'contact_fullname', label: 'Контакт', sortable: true },
                { key: 'contact_phone', label: 'Контактный номер', sortable: true },
                { key: 'call_type', label: 'Тип звонка', sortable: true },
                { key: 'bot_name', label: 'Сценарий', sortable: true },
                { key: 'account_number', label: 'Аккаунт', sortable: true },
                { key: 'bill_sec', label: 'Длительность', sortable: true },
                { key: 'cost', label: 'Стоимость', sortable: true },
                { key: 'tariff_name', label: 'Тариф', sortable: false },
                { key: 'retries', label: 'Попытки', sortable: true },
                { key: 'status', label: 'Статус', sortable: false },
                { key: 'caller_number', label: 'Вызывающий номер', sortable: false },
                { key: 'trunk_name', label: 'Транк', sortable: false },
                { key: 'pbx_server_name', label: 'Серверы', sortable: false },
                { key: 'demons_server_name', label: '', sortable: false },
                { key: 'updated_at', label: 'Обновлено', sortable: true },
                { key: 'delayed_at', label: 'Отложен', sortable: false },                
                { key: 'action',label: ''}
            ]
         }

        this.date_start = this.selectedDate[0];
        this.date_end   = this.selectedDate[1];

        await this.getData();
    },

    methods: {

        async showScheme(bot_uuid, track){
            this.$router.push({ name: 'Mindmap.edit', params: { type: 'bot', uuid: bot_uuid, track: track } })
        },

        async showModalItem(uuid, variables, storage, is_archive){
            
            this.modal_variables = [];

            for (let [key, value] of Object.entries(variables)) {
                if(typeof value !== 'object'){
                    value = String(value);
                    if(value.indexOf(".mp3") === -1 && (key !== 'var_voicemail_log' || this.session_user_item.role === 'administrator'))
                        this.modal_variables.push({
                            'key': key,
                            'value': value 
                        })
                }
            }

            this.record = null;
            if(variables.all_audio_record){
                let url = 'https://client.za-bota.com/calls';

                if(is_archive === 'true'){
                    url = url + '/archive';
                } else {
                    url = url + '/storage';
                }

                if(storage !== null){
                    url = url + '/' + storage;
                }

                this.record = url + '/' + uuid + '/' + variables.all_audio_record
            }

            this.showModal = true;

            return false;
        },

        // async downloadReport(){

        //     let url = "https://api.client.za-bota.com/v1/calls/report?" +
        //         '&date_start=' + this.date_start +
        //         '&date_end=' + this.date_end +
        //         '&filter=' + this.filter + 
        //         '&token=' + this.session_item.token;

        //     window.location.href = url;
        // },

        async onChangePeriod(item){
            if(item[0] && item[1]){
                this.date_start = moment(item[0]).format('DD.MM.YYYY')
                this.date_end   = moment(item[1]).format('DD.MM.YYYY')
                await this.getData();
            }
        },

        async onFiltered() {
            this.currentPage = 1;
            await this.getData();
        },
        async onSorted(){
            await this.getData();
        },
        async onChangePerPage(){
            this.currentPage = 1;
            await this.getData();
        },
        async onChangeCurrentPage(){
            await this.getData();
        },
        async getData(){

            this.tableLoading = true;

            this.status = this.$route.params.status ? this.$route.params.status : this.status;

            let data_send = {
                'limit'      : this.perPage,
                'page'       : this.currentPage,
                'sortBy'     : this.sortBy,
                'sortDesc'   : this.sortDesc === false ? 'ASC' : 'DESC',
                'date_start' : this.date_start,
                'date_end'   : this.date_end,
                'filter'     : this.filter,
                'filterOn'   : JSON.stringify(this.filterOn)
            }

            await this.$store.dispatch('calls/FETCH_CALLS_LIST', data_send);
            this.watch = true;
        }
    }
}
</script>

<template>
	<Layout>
        <div class="row page-title align-items-center">
            <div class="col-sm-4 col-xl-6">
                <h4 class="mb-1 mt-0"><i class="feather uil uil-phone-pause"></i>{{ title }}</h4>
            </div>

            <div class="col-sm-8 col-xl-6">
               
            </div>
        </div>

        <!-- <div class="row" >
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <StatisticChart />
              </div>
            </div>
          </div>
        </div> -->

        <div class="row">
            <div class="col-12">

                <div class="row" style="margin-top: 20px; margin-bottom: 5px">
                    <div class="col-sm-3 col-md-3">
                        <div id="tickets-table_length" class="dataTables_length">
                            <label class="d-inline-flex align-items-center">
                                Показывать&nbsp;
                                <b-form-select
                                    v-model="perPage"
                                    size="md"
                                    :options="pageOptions"
                                ></b-form-select
                                >&nbsp;записей
                            </label>
                        </div>
                    </div>
                    <!-- Search -->
                    <div class="col-sm-9 col-md-9">
                        <div
                            id="tickets-table_filter"
                            class="dataTables_filter text-md-right"
                        >
                            <div class="form-group mb-sm-0">
                                <label class="d-inline-flex align-items-center">
                                    Период: 
                                    <flat-pickr
                                        v-model="selectedDate"
                                        class="form-control ml-2"
                                        :config="dateConfig"
                                        @on-change="onChangePeriod"
                                        name="date"
                                    ></flat-pickr>
                                </label>
                                <label class="ml-3 d-inline-flex align-items-center">
                                    Поиск: 
                                    <b-form-input
                                        v-model="filter"
                                        type="search"
                                        @change="onFiltered()"
                                        placeholder="Введите текст..."
                                        class="form-control form-control-md ml-2"
                                    ></b-form-input>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- End search -->
                </div>                

                <div class="card">
                    <div class="card-body" style="padding-left: 0px; padding-right: 0px;">

                        <div class="table-responsive mb-0">
                            <b-table
                                :items="table_data"
                                :fields="fields"
                                responsive="sm"
                                current-page="1"
                                :class = "tableLoading ? 'loading' : ''"
                                :sort-by.sync="sortBy"
                                :sort-desc.sync="sortDesc"
                                :no-local-sorting="true"
                            >
                                <template #cell(action)="row">
                                    <div style="text-align: right;">
                                        <b-dropdown
                                            variant="link"
                                            class="float-right"
                                            right
                                            toggle-class="p-0 text-muted arrow-none"
                                        >
                                            <template v-slot:button-content>
                                                <i class="uil uil-ellipsis-v font-size-14"></i>
                                            </template>
                                            <b-dropdown-item v-show="row.item.variables && row.item.variables['track'] && row.item.variables['track'].length > 0" @click.prevent="showScheme(row.item.bot_uuid, row.item.variables['track'])" href="javascript: void(0);"
                                                ><i class="uil uil-sitemap mr-2"></i>Схема звонка</b-dropdown-item
                                            >
                                            <b-dropdown-item @click.prevent="showModalItem(row.item.uuid, row.item.variables, row.item.storage, row.item.is_archive)" href="javascript: void(0);"
                                                ><i class="uil uil-search-alt mr-2"></i>Просмотреть</b-dropdown-item
                                            >
                                        </b-dropdown>
                                    </div>
                                </template>                            
                            </b-table>
                        </div>
                    
                    </div>
                </div>

                <div class="row" style="margin-bottom: 30px">
                    <div class="col">
                        <div
                            class="dataTables_paginate paging_simple_numbers float-left"
                        >
                            <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination
                                    v-model="currentPage"
                                    :total-rows="total_rows"
                                    :per-page="perPage"
                                ></b-pagination>
                            </ul>
                        </div>
                    </div>
                </div>

            </div>
            <b-modal
                v-model="showModal"
                scrollable
                size="lg"
                title="Результаты звонка"
                title-class="font-18"
            >

                <h6 style="margin-bottom: 20px">Запись разговора</h6>
                <p v-if="record === null" style="text-align:center; margin-bottom: 20px">Запись отсутствует.</p>
                <p v-if="record !== null" style="margin-bottom: 20px">
                    <a :href="record" target="_blank">{{record}}</a>
                </p>
                
                <h6>Переменные</h6>
                
                <table v-if="modal_variables.length > 0" class="table table-striped mb-0">
                    <thead>
                    <tr>
                        <th scope="col">Код</th>
                        <th scope="col">Наименование</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in modal_variables">
                            <td>{{ item.key }}</td>
                            <td>{{ item.value }}</td>
                        </tr>
                    </tbody>
                </table>

                <p v-if="modal_variables.length === 0" style="text-align:center; margin-bottom: 20px">Список переменных пуст.</p>

                <template v-slot:modal-footer style="justify-content: flex-start !important">
                    <div style="width: 100%">
                        <b-button variant="light" class="btn" @click="showModal = false"
                        >Отменить</b-button
                        >
                    </div>
                </template>

            </b-modal>            
        </div>
	</Layout>
</template>

<style>
.table-responsive-sm{
    transition: all .5s;
}
.table-responsive-sm.loading{
    opacity: 0.3;
}
</style>